import React, { useState } from "react";
import { Database, RefreshCw } from "lucide-react";
import SubscriptionPlansSection from "./SubscriptionPlansSection";
import PerformerTeamManagement from "./PerformerTeamManagement";
import BuyAdminThemeToggle from "../shared/BuyAdminThemeToggle";
import "../shared/buyAdminThemeGlobals.css";
import styles from "./MasterData.module.css";

const MasterDataPage = () => {
  const [refreshKey, setRefreshKey] = useState(0);
  const [refreshing, setRefreshing] = useState(false);

  const handleRefresh = () => {
    setRefreshing(true);
    setRefreshKey((key) => key + 1);
    window.setTimeout(() => setRefreshing(false), 600);
  };

  return (
    <div className={`${styles.page} buy-admin-theme-scope`}>
      <div className={styles.header}>
        <div className={styles.titleRow}>
          <Database size={22} />
          <h1>Master Data</h1>
        </div>
        <div className={`${styles.headerActions} buy-admin-theme-actions`}>
          <button
            type="button"
            className={styles.refreshButton}
            onClick={handleRefresh}
            aria-label="Refresh master data"
            title="Refresh"
          >
            <RefreshCw size={16} className={refreshing ? styles.spin : ""} />
          </button>
          <BuyAdminThemeToggle iconOnly />
        </div>
      </div>

      <SubscriptionPlansSection refreshKey={refreshKey} />
      <PerformerTeamManagement refreshKey={refreshKey} />
    </div>
  );
};

export default MasterDataPage;
